var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("path", {
    attrs: {
      "fill-rule": "evenodd",
      d:
        "M87.204.666C77.411.462 21.731 2.719 11.695 12.573c-14.012 13.759-13.85 32.233-2.608 41.36 13.052 10.597 59.01 14.895 70.538 15.135 7.527.156 57.456 2.555 72.116-7.45 10.296-7.028 10.145-25.255-.34-39.756C141.059 5.9 93.834.803 87.205.666z"
    }
  })
}
var staticRenderFns = []
render._withStripped = true
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-415520c0", esExports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-415520c0","hasScoped":false,"transformToRequire":{"video":"src","source":"src","object":"src","embed":"src"},"preserveWhitespace":false,"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./components/_SVG/ShapeYearBtn2Tab.vue
// module id = fPNx
// module chunks = 1